import { AllHTMLAttributes, DetailedHTMLProps, useCallback } from 'react';
import { Search } from 'lucide-react';

import { Input, InputProps } from './ui/input';

import useDebounce from '@/hooks/use-debounce';
import { cn } from '@/lib/utils';

type SearchBarProps = {
  value: string | undefined;
  onValueChange?: (value: string) => void;
  debounce?: boolean;
  containerProps?: DetailedHTMLProps<AllHTMLAttributes<HTMLDivElement>, HTMLDivElement>;
} & InputProps;

export const SearchBar = ({ value, onValueChange, debounce, containerProps, ...inputProps }: SearchBarProps) => {
  const debouncedValue = useDebounce(value);
  const { className: containerClassName, ...containerRestProps } = containerProps || {};
  const { className: inputClassName, ...restInputProps } = inputProps;

  const handleValueChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onValueChange) {
        onValueChange(event.target.value);
      }
    },
    [onValueChange],
  );

  return (
    <div className={cn('relative w-full', containerClassName)} {...containerRestProps}>
      <Search className="absolute left-2.5 top-3 h-4 w-4" />
      <Input
        type="search"
        placeholder="Rechercher..."
        className={cn('appearance-none bg-background pl-8 shadow-none', inputClassName)}
        defaultValue={debounce ? debouncedValue : value}
        onChange={handleValueChange}
        {...restInputProps}
      />
    </div>
  );
};
